var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shibaUrl)?_c('div',{staticClass:"shiba"},[_c('h4',[_vm._v("Contribution")]),_c('div',{staticClass:"shiba-img"},[_c('img',{attrs:{"src":_vm.shibaUrl,"alt":"Not Found"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }